import { render, staticRenderFns } from "./AutomaticRemittanceComplete.vue?vue&type=template&id=fae4c294&scoped=true&"
import script from "./AutomaticRemittanceComplete.vue?vue&type=script&lang=js&"
export * from "./AutomaticRemittanceComplete.vue?vue&type=script&lang=js&"
import style0 from "./AutomaticRemittanceComplete.vue?vue&type=style&index=0&id=fae4c294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae4c294",
  null
  
)

export default component.exports